import styled from 'styled-components'

const GenericInput = styled.input`
  ::-webkit-outer-spin-button,
  ::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  width: ${(props) => (props.width ? props.width : '100%')};
  max-width: ${(props) => (props.maxWidth ? props.maxWidth : 'unset')};
  display: flex;
  position: relative;
  align-items: center;
  background-color: transparent;
  flex-direction: row;
  padding: 20px 40px;
  font-family: 'Nunito';
  font-size: ${(props) =>
    props.fSize ? `${props.fSize} !important` : '1.1rem'};
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.53;
  letter-spacing: -0.38px;
  text-align: center;
  border-radius: 19px;
  border: solid 1px #fff;
  box-sizing: border-box;
  font-family: 'Nunito';
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: -0.32px;
  text-align: ${(props) => (props.tAlign ? props.tAlign : 'left')};
  color: #ffffff;
  margin: ${(props) => (props.margin ? props.margin : '5px 0')};
  transition: all 0.6s cubic-bezier(0.165, 0.84, 0.44, 1);
  cursor: pointer;

  &.light {
    border: 1px solid #342152;

    &::placeholder {
      opacity: 0.5;
      color: #342152;
      font-size: ${(props) => (props.fSize ? props.fSize * 0.5 : '1.1rem')};
    }
  }
  input[type='text'] {
    cursor: text;
  }

  &::placeholder {
    opacity: 0.5;
    color: white;
    font-size: inherit;
  }

  &.dimension {
    &:after {
      content: 'cm';
    }
  }

  &.text-center {
    text-align: center;
  }

  &.no-border {
    border: 0px solid transparent;
  }

  &.color-white {
    color: white;
  }

  &.font-big-always {
    font-size: ${(props) =>
      props.fSize ? `${props.fSize + '!important'}` : '1.1rem'};
  }

  @media only screen and (max-width: 1700px) {
    font-size: 0.9rem;
    padding: 10px 20px;
  }
  @media only screen and (max-width: 1500px) {
    font-size: 0.8rem;
    padding: 10px 20px;
  }
  @media only screen and (max-width: 1400px) {
    font-size: 0.8rem;
    /* padding: 10px; */
    padding: 10px 20px;
  }
  @media only screen and (max-width: 1300px) {
    font-size: 0.8rem;
    padding: 10px 20px;
  }
  @media only screen and (max-width: 600px) {
    font-size: 1.2rem;
    padding: 20px 15px;
    box-sizing: border-box;
  }
`

export default GenericInput
